export default __webpack_public_path__ + "static/media/Relic of Dark Blessings.182fd2fd.jpg";